import { Popover } from "antd";
import { BiPlus } from "react-icons/bi";

const STEP_TYPES = [
  { type: "email", icon: "📧", label: "Email" },
  { type: "linkedinMessage", icon: "🔗", label: "LinkedIn" },
  { type: "call", icon: "📞", label: "Appel" },
  { type: "whatsapp", icon: "💬", label: "WhatsApp" },
  { type: "task", icon: "✅", label: "Tâche" },
  { type: "api", icon: "🔌", label: "API" },
  { type: "delay", icon: "⏳", label: "Délai" },
  { type: "condition", icon: "🔀", label: "Condition" },
];

const StepTypePicker = ({ onSelect, disabled }) => {
  const content = (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", width: 280 }}>
      {STEP_TYPES.map((st) => (
        <div
          key={st.type}
          onClick={() => !disabled && onSelect(st.type)}
          style={{
            padding: "10px 8px",
            borderRadius: 8,
            border: "1px solid #e8ecf0",
            cursor: disabled ? "not-allowed" : "pointer",
            textAlign: "center",
            opacity: disabled ? 0.5 : 1,
            transition: "all 0.15s",
          }}
          onMouseEnter={(e) => { if (!disabled) e.currentTarget.style.background = "#f0f4f8"; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
        >
          <div style={{ fontSize: 20 }}>{st.icon}</div>
          <div style={{ fontSize: 11, color: "#6b7280", marginTop: 2 }}>{st.label}</div>
        </div>
      ))}
    </div>
  );

  return (
    <Popover content={content} trigger="click" placement="bottom">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          padding: "6px 14px",
          borderRadius: 16,
          border: "1px dashed #d1d5db",
          color: "#6b7280",
          fontSize: 12,
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.5 : 1,
          background: "#f9fafb",
          transition: "all 0.15s",
        }}
      >
        <BiPlus size={14} />
        Ajouter une étape
      </div>
    </Popover>
  );
};

export default StepTypePicker;
